import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface ISubscriptionRestrictionsFilterProps {
  formik: FormikProps<any>;
  filterTypeOptions: Array<{ id: string; name: string }>;
  filterRestrictionScopeOptions: Array<{ id: string; name: string }>;
}

export function SubscriptionRestrictionsFilter(
  props: ISubscriptionRestrictionsFilterProps,
) {
  const { formik, filterTypeOptions, filterRestrictionScopeOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.type')}
          name="type"
          options={filterTypeOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.scope')}
          name="restrictionScope"
          options={filterRestrictionScopeOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
